import React from "react";
import { Col, Row } from "react-bootstrap";
import { Form, Input } from "antd";
// import AddPartner from "./AddPartner/AddPartner";
import TextInput from "../Common/UITextInput/TextInput";
import "../PartnerManagement/Style.css";
// import PartnerManagementListing from "./PartnerManagementListing/PartnerManagementListing";
import useWindowSize from "../../utils/useWindowSize";
import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";
import DashBoardComponent from "./DashBoardComponent";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";

const DashBoard = (props) => {
  const { width } = useWindowSize();

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const roleType = props.userDetail?.loggedInRoleType;

  return (
    <div className="" style={{ maxWidth: "100%" }}>
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}></Col>
        </Row>
      )}

      {width > 786 && (
        <Row className="mt-4 ">
          <Col>
            <h2>
              Hello,{" "}
              <span className="blue-cl">
                {props.userDetail?.firstName} {props.userDetail?.lastName}
              </span>
            </h2>
          </Col>
          <Col>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                      props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                      props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>
                <div className="content-login-data">
                  <ChangePassword />
                  <div className="admin-small-space"> </div>
                  <Logout />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Row className="mt-2" style={{ maxWidth: "100%" }}>
        <Col md={12} style={{ maxWidth: "100%", overflow: "hidden" }}>
          <DashBoardComponent />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps)(DashBoard);
